import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import CopyIcon from "./CopyIcon";

const CopyableInput = ({ 
  value, 
  name, 
  id, 
  placeholder, 
  onChange, 
  type = "text", 
  size = "sm", 
  isInvalid = false, 
  className = "",
  ...props 
}) => {
  return (
    <div className={`d-flex align-items-center gap-2 ${className}`}>
      <Form.Control
        type={type}
        name={name}
        id={id}
        placeholder={placeholder}
        value={value || ""}
        onChange={onChange}
        isInvalid={isInvalid}
        size={size}
        {...props}
      />
      {value && <CopyIcon text={value} />}
    </div>
  );
};

export default CopyableInput;
